/* eslint-disable class-methods-use-this */
const selectors = {
  days: '[data-countdown_days]',
  hours: '[data-countdown_hours]',
  minutes: '[data-countdown_minutes]',
  seconds: '[data-countdown_seconds]',
  heading: '[data-heading]',
  endHeading: '[data-end-heading]',
  headingMobile: '[data-heading-mobile]',
  endHeadingMobile: '[data-end-heading-mobile]',
  countdown: '#countdown',
};
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.endDate = window.countdown_timer.countdown_end_date;
    this.endTime = window.countdown_timer.coundtdown_end_time;
    this.enableSeconds =
      window.countdown_timer.countdown_enable_seconds !== 'false';
    this.days = document.querySelector(selectors.days);
    this.hours = document.querySelector(selectors.hours);
    this.minutes = document.querySelector(selectors.minutes);
    this.seconds = document.querySelector(selectors.seconds);
    this.countdownContainer = this.querySelector(selectors.countdown);
    this.heading = this.querySelector(selectors.heading);
    this.endHeading = this.querySelector(selectors.endHeading);
    this.headingMobile = this.querySelector(selectors.headingMobile);
    this.endHeadingMobile = this.querySelector(selectors.endHeadingMobile);
    this.interval = 60000;

    if (this.endDate === '') {
      return;
    }

    if (this.enableSeconds) {
      this.interval = 1000;
    }

    this.countDown();
    setInterval(() => this.countDown(), this.interval);
  }

  parseDate(date) {
    const parsed = Date.parse(date);
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(parsed)) {
      return parsed;
    }

    return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
  }

  setInitialised(state) {
    this.countdownContainer.dataset.countdownInitialised = state;
  }

  countDown() {
    let endDateString;
    this.dataset.display = true;

    if (this.endTime.length > 0) {
      endDateString = this.parseDate(`${this.endDate} ${this.endTime}`);
    } else {
      endDateString = Date.parse(this.endDate);
    }

    const today = new Date();
    const endDate = new Date(endDateString);
    const t = endDate.getTime() - today.getTime();

    if (t > 0) {
      this.setInitialised('true');

      this.heading.classList.remove('md:hidden');
      this.heading.classList.add('md:block');
      this.headingMobile.classList.remove('hidden');
      this.headingMobile.classList.add('block');
    }

    if (t <= 0) {
      this.countdownContainer.classList.add('invisible');

      this.heading.classList.remove('md:block');
      this.heading.classList.add('md:hidden');
      this.headingMobile.classList.remove('block');
      this.headingMobile.classList.add('hidden');
      this.endHeading.classList.remove('md:hidden');
      this.endHeading.classList.add('md:block');
      this.endHeadingMobile.classList.remove('hidden');
      this.endHeadingMobile.classList.add('block');

      this.setInitialised('false');

      return;
    }

    const day = Math.floor(t / (1000 * 60 * 60 * 24));
    const hour = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minute = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));

    this.days.innerText = day;
    this.hours.innerText = hour;
    this.minutes.innerText = minute;

    if (this.enableSeconds) {
      const second = Math.floor((t % (1000 * 60)) / 1000);
      this.seconds.innerText = second;
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);
